module.exports = __webpack_public_path__ + "img/car-electric-first.b5fec3e8.png";